import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import("@/views/Home.vue"),
    meta: {
      logged: false
    }
  },
  {
    path:'/f/:uuid',
    name: 'DocumentCommandeV2',
    component: () => import( "@/views/document/FileV2.vue"),
    meta:{
      logged:false
    }
  },
  {
    path:'/f2/:uuid',
    name: 'DocumentCommande',
    component: () => import( "@/views/document/File.vue"),
    meta:{
      logged:false
    }
  },
  {
    path:'/i/:token',
    name: 'InventaireV1',
    component: () => import( "@/views/document/InventaireV1.vue"),
    meta:{
      logged:false
    }
  },
  {
    path:'/a/:key',
    name: 'DocumentCommande',
    component: () => import( "@/views/Agenda.vue"),
    meta:{
      logged:false
    }
  }        
];

const router = new VueRouter({
  routes,
});
export default router;
